import React from 'react';
import ChurnChart from './ChurnChart';

export function Churn({ sprints, units }) {
  return (
    <>
      <ChurnChart data={sprints} units={units} />
    </>
  );
}

export default Churn;
